import type {
  ComplexityAssessmentId,
  EngagementId,
  Scoping,
  ScopingDecision,
  SendScopingFollowUp,
  TprmScopeId,
} from "platformed-client/types";
import {platformedClient} from "../..";
import {invalidateQueries, q} from "../../../state";

export async function get(complexityAssessmentId: ComplexityAssessmentId): Promise<Scoping> {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scoping",
    {path: {complexity_assessment_id: complexityAssessmentId}},
  );
}

export async function decide(
  complexityAssessmentId: ComplexityAssessmentId,
  scopeId: TprmScopeId,
  decision: ScopingDecision,
): Promise<Scoping> {
  const res = await platformedClient.internalRequest(
    "put",
    "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scopes/{scope_id}/scoping",
    {path: {complexity_assessment_id: complexityAssessmentId, scope_id: scopeId}, body: decision},
  );
  await invalidateQueries([q.tprm.complexityScoping.filter(complexityAssessmentId)]);
  return res;
}

export async function sendFollowUp(
  engagementId: EngagementId,
  complexityAssessmentId: ComplexityAssessmentId,
  body: SendScopingFollowUp,
): Promise<Scoping> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/complexity_assessment/{complexity_assessment_id}/scoping/send",
    {path: {complexity_assessment_id: complexityAssessmentId}, body},
  );
  await invalidateQueries([
    q.tprm.complexityScoping.filter(complexityAssessmentId),
    q.tprm.engagementExternalQuestionnaires.filter(engagementId),
    q.tprm.externalQuestionnaires.filter(),
    q.tprm.engagementAuditPlan.filter(engagementId),
  ]);
  return res;
}
